<script setup lang="ts">
import { onMounted, useTemplateRef } from 'vue'
import { TimerOrientation, TimerProgression, useIdleTimer } from '@nsftx/seven-nxg-retail-vue-sdk'
import { NXGRetailTimerBar } from '@nsftx/seven-nxg-retail-vue-sdk/ui'
import { useDmCoreSpaceOperatorAuthStore } from '@nsftx/seven-client-retail-vue-dm-core'
import { logService } from '@nsftx/seven-client-retail-utils'
import errorParser from '@/utils/errorParser'
import { redirectToSsbt } from '@/utils/ssbtRedirect'

const LOG_PREFIX = '[SBOIdleTimerBar]'
const timerRef = useTemplateRef('timerRef')
const { logoutOperator, clearOperatorSession } = useDmCoreSpaceOperatorAuthStore()

const idleTime = 120_000
const transitionDelay = 5_000
const timerPosition = {
  left: 0,
  bottom: 0
}

const onTimerReset = () => {
  timerRef.value?.resetTimerAnimation()
}

const idleTimer = useIdleTimer({
  duration: idleTime,
  transitionDelay,
  onEnd: async () => {
    try {
      await logoutOperator()
    } catch (error) {
      logService.error(`${LOG_PREFIX} Operator logout failed.`, {
        code: 'SBO_OPERATOR_LOGOUT_ERROR',
        ...errorParser.parseUpstream(error)
      })
      clearOperatorSession()
    }

    redirectToSsbt()
  },
  onReset: onTimerReset,
  onTick: () => {}
})

onMounted(() => {
  idleTimer.startIdleTimer()
})
</script>

<template>
  <div class="timer-bar-wrapper">
    <NXGRetailTimerBar
      ref="timerRef"
      height="56px"
      :duration="idleTime"
      :transition-delay="transitionDelay"
      bg-color="var(--st-idle-bar-bg-color)"
      loading-bar-color="var(--nxgds-mapped-color-surface-primary)"
      :orientation="TimerOrientation.Vertical"
      :progression-style="TimerProgression.DESC"
      :position="timerPosition"
    />
  </div>
</template>

<style lang="scss">
.timer-bar-wrapper {
  position: relative;
  height: 56px;
  width: 6px;
  --st-idle-bar-bg-color: rgba(from var(--nxgds-mapped-color-surface-primary) r g b / 0.2);
  margin: 0 var(--nxgds-alias-spacing-xs);
}
</style>
